(() => {
  const cartApi = /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:[/?#]|$)/;

  let timer;
  const initLegal = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      window?.roarJs?.Legal?.init();
    }, 600);
  };

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = args[0] instanceof Request ? args[0].url : String(args[0]);

    if (response.ok && cartApi.test(url)) initLegal();

    return response;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...args) {
    this.addEventListener("load", () => {
      if (this.status >= 200 && this.status < 300 && cartApi.test(String(url))) {
        initLegal();
      }
    }, { once: true });

    return originalOpen.call(this, method, url, ...args);
  };
})();

// Code added by RoarTheme App on 11 Oct 2026